import { render, staticRenderFns } from "./VerticalBanner.vue?vue&type=template&id=3c2b6d60&scoped=true&"
import script from "./VerticalBanner.vue?vue&type=script&lang=js&"
export * from "./VerticalBanner.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBanner.vue?vue&type=style&index=0&id=3c2b6d60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b6d60",
  null
  
)

export default component.exports